import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'c-listbox',
    templateUrl: './listbox.component.html',
    styleUrls: ['./listbox.component.css'],
    standalone: false
})
export class ListboxComponent implements OnInit {
  // Recibe lista de opciones como arreglo
  @Input() options!: any[];

  // Categoría recibida, opciones seleccionadas
  @Input() selectedOption: any = null;
  @Output() selectedOptionChange = new EventEmitter<any>();
  // Nombre de opción a mostrar
  @Input() itemProperty: string = '';
  // ID de la categoría
  @Input() identificadorI: string = '';

  // Subopción seleccionada
  @Input() subOpt: string = '';
  // Nombre de subopción a mostrar
  @Input() subItemProperty: string = '';
  // ID de la subcategoría
  @Input() identificadorS: string = '';

  // Variable para mostrar lista de primeng (subopciones) o input para un solo casillero
  hasSubOptions: boolean = false;
  flattenedOptions: any[] = [];
  nombreCategoria: string = '';
  idCategoria: number[] = [];

  ngOnInit(): void {
    /**
     * @description Si existen subcategorías en el arreglo, se muestra listbox con
     * un casillero para todas las opciones e individuales para cada opción existente
     */
    if (this.options && this.options.length === 1) {
      const category = this.options[0];

      this.nombreCategoria = category[this.itemProperty];
      this.idCategoria = category[this.identificadorI];

      const subItems = category[this.subOpt] || [];
      this.hasSubOptions = Array.isArray(subItems) && subItems.length > 0;

      if (this.hasSubOptions) {
        this.flattenedOptions = subItems.map((subItem: any) => ({
          idCategoria: this.idCategoria,
          id: subItem[this.identificadorS],
          nombre: subItem[this.subItemProperty],
        }));
      }
    }
  }

  /**
   * @description Emite los valores para lista de categoría y subcategoría
   */
  onModelChange(value: any[]): void {
    this.selectedOption = value;

    // Emite al componente padre
    this.selectedOptionChange.emit(value);
  }

  /**
   * @description Emite los valores para una categoría individual
   */
  onSingleCheckboxChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    // Emite id de categoría y nombre
    const emitValue = isChecked
      ? [{ id: this.idCategoria, nombre: this.nombreCategoria }]
      : [];

    this.selectedOption = isChecked ? emitValue[0] : null;

    this.selectedOptionChange.emit({
      idCategoria: this.idCategoria,
      nombre: this.nombreCategoria,
    });
  }
}
